import React, { forwardRef } from "react";
import { Grid } from "../../../primitives/Grid/Grid";
import { SimpleGridBaseProps, SimpleGridComponent } from "./SimpleGrid.types";

/**
 * SimpleGrid component - A polymorphic component for easy grid layouts
 */
export const SimpleGrid = forwardRef(function SimpleGrid(
  props: SimpleGridBaseProps & { as?: React.ElementType },
  ref
) {
  const { columns = 0, spacing, minChildWidth, autoFit, as, ...rest } = props;

  // Calculate gridTemplateColumns based on provided props
  let gridTemplateColumns;

  if (minChildWidth) {
    // Use minmax with auto-fit or auto-fill for responsive grid
    const repeat = autoFit ? "auto-fit" : "auto-fill";
    gridTemplateColumns = `repeat(${repeat}, minmax(${minChildWidth}, 1fr))`;
  } else if (columns > 0) {
    // Use traditional fixed columns if specified
    gridTemplateColumns = `repeat(${columns}, 1fr)`;
  }

  return (
    <Grid
      ref={ref}
      as={as}
      gridTemplateColumns={gridTemplateColumns}
      gap={spacing}
      {...(rest as Record<string, unknown>)}
    />
  );
}) as SimpleGridComponent;

// Set display name for debugging
SimpleGrid.displayName = "SimpleGrid";

export default SimpleGrid;
